var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "notifications-page" } },
    [
      _c("NotificationSidebar", {
        attrs: { filter: _vm.filter },
        on: { filtered: _vm.updateFilters },
      }),
      _vm._v(" "),
      _c("div", { ref: "container", staticClass: "page-content" }, [
        _c("header", [_vm._v(_vm._s(_vm.$t("notification.notifications")))]),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "toolbar" },
          [
            _c(
              "div",
              { staticClass: "btnGroup" },
              [
                _c(
                  "SupsisButton",
                  {
                    attrs: {
                      classNames: "btnGroupItem",
                      primary: !_vm.includeAll,
                    },
                    on: {
                      click: function ($event) {
                        _vm.includeAll = false
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.unreadTitle")) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "SupsisButton",
                  {
                    attrs: {
                      classNames: "btnGroupItem",
                      primary: _vm.includeAll,
                    },
                    on: {
                      click: function ($event) {
                        _vm.includeAll = true
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.$t("message.all")) +
                        "\n                "
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("SupsisButton", { on: { click: _vm.markAsSeenAll } }, [
              _c("i", { staticClass: "material-icons" }, [_vm._v("done")]),
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("mail.markAsAllRead")) +
                  "\n            "
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "page-content-wrapper" },
          [
            _c("NotificationListView", {
              attrs: {
                notifications: _vm.notifications,
                loading: _vm.loading,
                "group-by-date": true,
              },
              on: { "load-more": _vm.loadMore },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }